var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-events"},[_vm._v(" Events ")])
}
var staticRenderFns = []

export { render, staticRenderFns }